import { th } from "date-fns/locale"
import { TableShimmer } from "../../../ShimmerUI"
import NotFound from "../../../Notfound"
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
type Column = {
  header: string
  accessor?: string
  render?: (row: any) => React.ReactNode
  sortable?: boolean
}
type ReusableTableProps = {
  columns: Column[]
  data?: any[]
  loading?: boolean
  onSort?: (field: string) => void
  sortField?: string
  sortOrder?: string
  headerColor?: string
}
const ReusableTable = ({
  columns,
  data,
  loading,
  onSort,
  sortField,
  sortOrder,
  headerColor = '#5BC0BE',
}: ReusableTableProps) => {
  return (
    <div className="overflow-hidden bg-white rounded-lg shadow">
      <div className="overflow-x-auto">
        <table className="min-w-full">
          {/* HEADER */}
          <thead>
            <tr
              className="text-sm text-left text-white uppercase"
              style={{ backgroundColor: headerColor }}
            >
                            {columns.map((col, index)=>(
                               <th
  key={index}
  className="px-3 sm:px-6 py-2 sm:py-3 cursor-pointer whitespace-nowrap"
  onClick={() => col.sortable && onSort?.(col.accessor!)}
>
  <div className="flex items-center gap-1">

    {col.header}

    {col.sortable && (
      <div className="flex flex-col leading-none">

        {sortField === col.accessor && sortOrder === "asc" ? (
          <ArrowDropUpIcon fontSize="small" />
        ) : (
          <ArrowDropUpIcon fontSize="small" />
        )}

        {sortField === col.accessor && sortOrder === "desc" ? (
          <ArrowDropDownIcon fontSize="small" />
        ) : (
          <ArrowDropDownIcon fontSize="small" />
        )}

      </div>
    )}

  </div>
</th>
                            ))}
                        </tr>
                    </thead>
                    {/* BODY */}
                    <tbody>
                        {loading ? (
                            <TableShimmer columns={columns.length}/>
                        ) : data?.length === 0 ? (
                            <tr>
                            <td colSpan={columns.length} className="p-4 text-center">
                                <NotFound/>
                            </td>
                            </tr>
                        ) : (
                            data?.map((row, rowIndex) => (
                                <tr
                                    key={row._id || row.id || rowIndex}
                                    className="hover:bg-gray-50"
                                >
                                    {columns.map((col, colIndex) => (
                                        <td key={colIndex} className="px-3 sm:px-6 py-2 sm:py-4 text-sm">
                                            {col.render ? col.render(row) : row[col.accessor as keyof typeof row] || "NA"}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default ReusableTable